<div class="search-box">
  <input type="search" name="search" id="search" #inputSearch [placeholder]="'Search' | translate">
</div>